<mat-form-field appearance="outline" color="primary">
  <mat-select
    (openedChange)="$event ? null : resetKeyword()"
    [(ngModel)]="_selectedOption"
    (ngModelChange)="
      action.emit({
        type: 'selectedOption',
        codeItem: type,
        value: _selectedOption
      })
    "
    placeholder="{{
      'cp.codeItemOptionSelect.placeholder.pleaseSelect' | translate
    }}"
    (selectionChange)="keyword = null"
  >
    <mat-select-trigger>
      {{ _selectedOption }}
    </mat-select-trigger>
    <mat-form-field
      appearance="outline"
      class="add-input outline no-placeholder paddingless"
    >
      <input
        matInput
        placeholder="{{
          'cp.codeItemOptionSelect.placeholder.addAnItem' | translate
        }}"
        [(ngModel)]="keyword"
        (keydown.enter)="
          $event.stopPropagation();
          action.emit({ type: 'addOption', codeItem: type, value: keyword })
        "
        (keydown.space)="$event.stopPropagation()"
      />
      <mat-icon matSuffix *ngIf="keyword" (click)="keyword = null"
        >close</mat-icon
      >
    </mat-form-field>
    <mat-option *ngIf="items?.length === 0">-</mat-option>
    <mat-option
      *ngFor="let item of items | searchFilter: keyword:'name'; let i = index"
      [class.deletable]="item.deletable"
      [value]="item.name"
    >
      <p>
        {{ item.name }}
      </p>
      <div>
        <button
          mat-button
          color="warn"
          class="delete-button"
          *ngIf="item.deletable"
          (click)="
            $event.stopPropagation();
            action.emit({
              type: 'deleteOption',
              codeItem: type,
              value: item.name
            })
          "
        >
          {{ 'common.actions.delete' | translate }}
        </button>
        <mat-icon class="check-icon" *ngIf="_selectedOption === item.name"
          >check</mat-icon
        >
      </div>
    </mat-option>
  </mat-select>
</mat-form-field>
